import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  post: {
    display: "block",
    width: "100%",
    "overflowWrap":"break-word"
  },
  text: {
    "display": "inline-block"
  },
  post_image: {
    width: "100%"
  }
}))